import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useAuthNOK } from "../context/AuthContextNok";

export const LoginUser = () => {
  const { login } = useAuth(); // Para User
  const { loginNOK } = useAuthNOK(); // Para NOK
  const [selectedRole, setSelectedRole] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // ✅ Leer el parámetro de la URL para determinar el rol
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const roleFromUrl = queryParams.get("role");

    if (roleFromUrl === "user") {
      setSelectedRole("User");
    } else if (roleFromUrl === "nok") {
      setSelectedRole("Next of kin");
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    let apiUrl = "";
    let requestBody = {};

    if (selectedRole === "User") {
      apiUrl =
        "https://vivebackend-a5hdfhhtbphgd4ed.canadacentral-01.azurewebsites.net/api/login";
      requestBody = { User: phoneNumber, Password: password };
    } else if (selectedRole === "Next of kin") {
      apiUrl =
        "https://vivesupportnokback-ctfcg7hfgtd6g0h2.canadacentral-01.azurewebsites.net/api/loginNok";
      requestBody = { phoneNoK: phoneNumber, PasswordHash: password };
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      console.log("📢 Datos recibidos de la API:", data);

      if (response.ok && data.win === 1) {
        if (selectedRole === "User") {
          // ✅ Guardar datos de usuario normal
          const userData = {
            token: data.data.token,
            userId: data.data.userId,
            firstName: data.data.firstName,
            lastName: data.data.lastName,
            phoneNumber: data.data.PhoneNumber,
            email: data.data.Email,
            rol: data.data.rol,
          };
          login(userData);
          console.log("✅ Usuario guardado en contexto:", userData);
          window.location.href = "/homeUser";
        } else if (selectedRole === "Next of kin") {
          // Verificamos si requiere ingresar el nombre antes de continuar
          if (
            data.responseCode === 201 &&
            data.responseMessage ===
              "You must enter your name before you can log in." &&
            data.data?.contactListId
          ) {
            window.location.href = `/addNameNok?contactListId=${data.data.contactListId}`;
            return;
          }

          const nokData = data.data[0];
          if (!nokData) {
            console.error("❌ Error: No se encontró información del usuario.");
            setError("❌ Invalid credentials. Please try again.");
            return;
          }

          const nokUserData = {
            nokId: nokData.contactListId,
            token: nokData.jwt,
            nameContact: nokData.NameContact || "N/A",
            phoneNumber: nokData.PhoneNumberContact || "N/A",
            allowed: nokData.allowed || "0",
            contactListId: nokData.contactListId,
            enableSMS: parseInt(nokData.enableSMS) === 1,
            enableVoice: parseInt(nokData.enableVoice) === 1,
          };

          loginNOK(nokUserData);
          console.log("✅ Usuario NOK guardado en contexto:", nokData);
          window.location.href = "/homeNOK";
        }
      } else {
        setError("❌ Invalid credentials. Please try again.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("❌ Network error. Please try again later.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.loginBox}>
        {!selectedRole ? (
          <>
            <h2 style={styles.title}>Who are you?</h2>
            <button
              onClick={() => setSelectedRole("User")}
              style={styles.selectionButton}
            >
              You are User?
            </button>
            <button
              onClick={() => setSelectedRole("NOK")}
              style={styles.selectionButton}
            >
              You are NOK?
            </button>
          </>
        ) : (
          <>
            <h2 style={styles.title}>{selectedRole} Login</h2>
            <form onSubmit={handleLogin} style={styles.form}>
              <div style={styles.inputContainer}>
                <label style={styles.label}>Phone Number:</label>
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                  style={styles.input}
                  placeholder="Enter your phone number"
                />
              </div>

              <div style={styles.inputContainer}>
                <label style={styles.label}>Password:</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={styles.input}
                  placeholder="Enter your password"
                />
              </div>

              {error && <p style={styles.errorMessage}>{error}</p>}

              <button type="submit" style={styles.button}>
                Login
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

// Estilos
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #0A3A2C, #167D56)",
  },
  loginBox: {
    background: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    width: "350px",
    animation: "fadeIn 0.8s ease-in-out",
  },
  title: {
    marginBottom: "20px",
    fontSize: "22px",
    fontWeight: "bold",
    color: "#0A3A2C",
  },
  selectionButton: {
    padding: "12px",
    margin: "10px",
    backgroundColor: "#1a9766",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    width: "100%",
  },
  form: { display: "flex", flexDirection: "column" },
  inputContainer: { marginBottom: "15px", textAlign: "left" },
  label: { fontSize: "14px", fontWeight: "bold", color: "#333" },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  button: {
    padding: "12px",
    backgroundColor: "#0A3A2C",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  errorMessage: { color: "red", fontSize: "14px", marginTop: "10px" },
};

export default LoginUser;
